<template>
  <v-dialog
    v-model="dialog"
    persistent
    fullscreen
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            :disabled="exam.exam_attempts.length>=exam.max_attempt"
            color="primary"
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-book-open
            </v-icon>
          </v-btn>
        </template>
        <span>Start Exam</span>
      </v-tooltip>
    </template>

    <v-container
      class="fill-height white-backgroud"    
      fluid
    >
      <v-row
        v-if="!examEnded && !examCompleted"
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="8"
        >
          <div
            v-if="questions.length > 0"
            class="font-14 text-right"
          >
            Time for answering the question: 
            <span class="font-weight-medium green-color">
              {{ time }}
            </span>
          </div>
          <v-card class="card-min-height">
            <v-card-title class="white-color green-background">
              {{ exam.name }}
            </v-card-title>

            <v-overlay
              v-if="loadQuestionLoading"
              color="transparent"
            >
              <v-progress-circular
                color="purple"
                indeterminate
              />
            </v-overlay>

            <div v-if="questions.length > 0 && !loadQuestionLoading">
              <v-container class="question-answer-min-height">
                <div
                  v-for="(question,index) in questions"
                  :key="index"
                >
                  <h4 class="font-weight-bold">
                    Question {{ currentQuestion }} of {{ totalQuestion }}<span class="font-weight-regular float-right">[Marks: {{ question.mark }}]</span>
                  </h4>

                  <div
                    class="question-font-size"
                    v-html="question.content"
                  />

                  <v-radio-group
                    v-if="question.question_type_id === 1"
                    v-model="answerIndex"
                    v-validate="'required'"
                    :error-messages="errors.collect('answerIndex')"
                    data-vv-as="answer"
                    data-vv-name="answerIndex"
                  >
                    <v-radio 
                      v-for="(question,index) in question.answer_choices"
                      :key="index"
                      class="mb-4 font-16 ml-6"
                      :value="question.index"
                      :label="question.content"
                    /> 
                  </v-radio-group>

                  <div v-if="question.question_type_id === 2">
                    <v-textarea
                      v-model="structureAnswer"
                      v-validate="'required'"
                      outlined
                      label="Answer"
                      rows="2"
                      auto-grow
                      :error-messages="errors.collect('structureAnswer')"
                      data-vv-name="structureAnswer"
                      data-vv-as="answer"
                    />
                  </div>
                </div>
              </v-container>
              <v-container class="pt-0">
                <v-btn
                  color="success"
                  @click="submitForm"
                >
                  submit answer
                </v-btn>
              </v-container>
            </div>

            <div v-if="!loadQuestionLoading && questions.length < 1">
              <div class="text-center">
                <h3 class="font-weight-bold">
                  {{ exam.name }}
                </h3>
                <h4><span class="font-weight-bold"> Duration:</span> {{ exam.duration }} minutes</h4>
                <h4><span class="font-weight-bold">Exam Available:</span> {{ $moment(exam.start_date).format('DD-MM-YYYY HH:mm A') }} - {{ $moment(exam.end_date).format('DD-MM-YYYY HH:mm A') }}</h4>
                <h4><span class="font-weight-bold">Passing Score:</span> {{ exam.passing_score }}%</h4>
                <h4><span class="font-weight-bold"> Max. Attempts:</span> {{ exam.max_attempt }}</h4>
                <h4 class="font-weight-bold color-info">
                  <span> Current Attempts:</span> {{ exam.exam_attempts.length +1 }}
                </h4>
                <v-divider />
                <h4 class="font-weight-bold">
                  Reminder:
                </h4>
                <h5 class="red--text">
                  <b class="font-17">Close the browser</b> or <b class="font-17">click back</b> or <b class="font-17">refresh </b>will results in immediate termination of exam.
                </h5>
                
                <v-divider />
              </div>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  align="center"
                  text
                  @click="dialog=false"
                >
                  I'm just not yet ready
                </v-btn>
                <v-btn
                  align="center"
                  color="success"
                  @click="startExam"
                >
                  Start The Test
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row
        v-if="examCompleted || examEnded"
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="8"
        >
          <v-card class="card-min-height">
            <v-card-title class="white-color green-background">
              {{ exam.name }}
            </v-card-title>

            <v-container>
              <h3 class="font-weight-bold text-center">
                <span
                  :class="{ 
                    'red--text': examEnded, 
                    'green--text': !examEnded 
                  }"
                >{{ examEnded?"TIME'S UP": "End Of Exam" }}
                </span>
              </h3>
              <div class="px-10">
                <span class="font-weight-bold ml-n3">Test Summary</span>
                <v-row class="grey-background">
                  <v-col
                    v-if="pendingResult"
                    cols="12"
                    class="font-weight-medium text-center font-24 warning--text"
                  >
                    Result is still in process
                  </v-col>

                  <v-col
                    v-else
                    class="font-weight-medium text-center pt-0 font-24"
                    cols="12"
                  >
                    <div class="font-18 py-3">
                      Your Score is:
                    </div>

                    <span
                      :class="{ 
                        'red--text font-24': (exam.passing_score > finalResult), 
                        'green--text font-24': (exam.passing_score <= finalResult) 
                      }"
                    >
                      <v-progress-circular 
                        v-if="!finalResult"
                        indeterminate
                        color="green"
                      />
                      <br v-if="!finalResult">
                      <span v-else>{{ finalResult }}% ({{ exam.passing_score > finalResult?'FAIL':'PASS' }})</span>
                    </span>
                  </v-col>
                </v-row>
                <p class="ml-n3 my-4 font-weight-regular font-16">
                  Thank you for taking the test!
                </p>
              </div>
            </v-container>

            <v-card-actions>
              <v-spacer />
              <v-btn
                align="center"
                text
                @click="closeDialog"
              >
                Close
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      exam: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        examEnded: false, 
        examCompleted: false,
        loadQuestionLoading: false, 
        pendingResult: false,
        questions: [],
        totalQuestion: 0,
        currentQuestion: 0,
        examAttempt: 0,
        questionNo: 0,
        finalResult: 0,
        totalMarks: 0,
        answerIndex: null,
        structureAnswer: null,
        interval: null,
        date: this.$moment().startOf('day'),
      }
    },
    computed: {
      time () {
        return this.date.format('HH:mm:ss')
      },
    },
    watch: {
      dialog: function (value) {
        if (value) { 
          this.exam.exam_questions.forEach(examQuestion => {
            this.totalMarks = this.totalMarks + examQuestion.mark
          })

          window.addEventListener('beforeunload', this.disableRefreshAndClose)
        } else {
          window.removeEventListener('beforeunload', this.disableRefreshAndClose)
        }
      },
    },

    methods: {
      disableRefreshAndClose (e) {
        e.preventDefault()
        e.returnValue = ''
      },
      updateScore (score) {
        this.$api.examAttempts().update(this.examAttempt.id, this.prepareTestDetailFormData(score))
          .then(res => { })
      },
      getExamMarks () {
        this.$api.examAttemptAnswers().list(this.examAttempt.id)
          .then(res => {
            let markObtained = 0

            if (res.status === 202) { // processing
              this.pendingResult = true
              this.updateScore(null)
            } else if (res.status === 200) {
              res.data.forEach(data => {
                markObtained = markObtained + data.mark
              })

              this.finalResult = ((markObtained / this.totalMarks) * 100).toFixed(2)
              this.updateScore(this.finalResult)
            }
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.$api.examAttemptAnswers().create(this.examAttempt.id, this.questionNo, this.prepareFormData())
              .then(res => {
                this.answerIndex = null
                this.structureAnswer = null

                this.loadExamQuestions()
              })
          })
      },
      startExam () {
        this.$api.examAttempts().create({ 'exam_id': this.exam.id })
          .then(res => {
            if (res.status === 201) {
              this.examAttempt = res.data
              this.loadExamQuestions()
              this.timer()
            }
          })
      },
      loadExamQuestions () {
        this.loadQuestionLoading = true
        this.$api.participantExamQuestions().list(this.exam.id, '?page=' + (this.currentQuestion + 1))
          .then(res => {
            this.setPaginationDetails(res.data)

            res.data.data.map(question => {
              this.questionNo = question.id
            })

            if (res.data.data.length > 0) {
              this.questions = res.data.data
            } else {
              this.examCompleted = true
              clearInterval(this.interval)
              this.getExamMarks()
            }
           
            this.loadQuestionLoading = false
          })
      },
      timer () {
        this.date.add(this.exam.duration, 'minutes')
        this.interval = setInterval(() => {
          let zero = this.$moment().startOf('day').format('HH:mm:ss')
          let timeLeft = this.$moment(this.date.subtract(1, 'seconds')).format('HH:mm:ss')

          let x = this.$moment(zero, 'HH:mm:ss')
          let y = this.$moment(timeLeft, 'HH:mm:ss')
            
          if (y.diff(x, 'seconds') > 0) {
            this.date = this.$moment(timeLeft, 'HH:mm:ss')
          } else {
            clearInterval(this.interval)
            this.examEnded = true
            this.getExamMarks()
          }
        }, 1000)
      },
      setPaginationDetails (page) {
        this.totalQuestion = page.total
        this.currentQuestion = page.from
      },
      prepareFormData () {
        if (this.structureAnswer) {
          return {
            'answer_index': 0,
            'structure_answer': this.structureAnswer,
          }
        }
        return {
          'answer_index': this.answerIndex,
          'structure_answer': this.structureAnswer,
        }
      },
      prepareTestDetailFormData (score) {
        let startTime = this.$moment().startOf('day').add(this.exam.duration, 'minutes')
        let endTime = this.$moment(this.time, 'HH:mm:ss')
        let duration = startTime.diff(endTime, 'minutes') + 1

        return {
          'score': score,
          'duration': duration,
        }
      },
      closeDialog () {
        this.questions = []
        this.examEnded = false
        this.examCompleted = false
        this.pendingResult = false
        this.totalQuestion = 0
        this.currentQuestion = 0
        this.totalMarks = 0
        this.date = this.$moment().startOf('day')
        this.$emit('completed')
        this.dialog = false
      },
    },
  }
</script>

<style scoped>
.question-font-size >>> p {
  font-size:16px !important
}
.white-backgroud{
  background:white
}
.font-14{
  font-size:14px
}
.font-16{
  font-size:16px
}
.font-17{
  font-size:17px
}
.font-18{
  font-size:18px
}
.font-24{
  font-size:24px
}
.red-color{
  color:red;
}
.white-color{
  color:white;
}
.green-color{
  color:#5cb860;
}
.green-background{
  background:#5cb860;
}
.question-answer-min-height{
  min-height:270px
}
.card-min-height{
  min-height:350px
}
.submit-button-position{
  position: absolute;
  bottom:14px
}
.grey-background{
  background-color: #fafafa;
}
.color-info{
  color:#5bc0de
}
</style>
